import { t } from '../../config/translations';
import { returnReasonOptions } from '../../utils/communSchemas';

export const suiviProductSchema: any = {
  get title() {
    return t('schema.productTracking');
  },
  type: 'object',
  properties: {
    productId: {
      type: 'string',
      get title() {
        return t('schema.reference');
      },
      decorators: { search: true, searchable: true, id: { viewAll: true } },
    },
    productOldNart: {
      type: 'string',
      get title() {
        return t('schema.replacedRef');
      },
      decorators: { search: true, searchable: true },
    },
    productName: {
      type: 'string',
      get title() {
        return t('schema.designation');
      },
      decorators: { search: true, searchable: true },
    },
    productSize: {
      type: 'string',
      get title() {
        return t('schema.size');
      },
      decorators: { search: true },
    },
    productQuantity: {
      type: 'string',
      get title() {
        return t('schema.qtyReturned');
      },
      decorators: { search: true },
    },
    productAction: {
      type: 'string',
      get title() {
        return t('schema.returnType');
      },
      uniforms: {
        checkboxes: true,
        options: [
          {
            get label() {
              return t('schema.credit');
            },
            value: 'ERM',
            color: 'blue',
          },
          {
            get label() {
              return t('schema.exchange');
            },
            value: 'ECS',
            color: 'blue',
          },
          {
            get label() {
              return t('schema.refund');
            },
            value: 'REM',
            color: 'blue',
          },
        ],
      },
      decorators: {
        search: true,
        filterable: {
          options: [
            {
              get label() {
                return t('schema.credit');
              },
              value: 'ERM',
            },
            {
              get label() {
                return t('schema.exchange');
              },
              value: 'ECS',
            },
            {
              get label() {
                return t('schema.refund');
              },
              value: 'REM',
            },
          ],
        },
      },
    },
    productLitige: {
      type: 'string',
      get title() {
        return t('schema.clientReason');
      },
      uniforms: {
        checkboxes: true,
        options: returnReasonOptions,
      },
      decorators: { search: true },
    },
    suiviId: {
      type: 'string',
    },
  },
  required: [],
};
